import { t } from "../../i18n/t";

export interface ConceptRow {
  name: string;
  support: string;
  reason: string | null;
}

/**
 * 2A-1. The source's named features that are not migrated at all (Xero's `XERO_CONCEPTS`: item list, payroll,
 * repeating invoices, bank rules, ...). Shown on the Scope screen and again on the scorecard, never collapsed:
 * an accountant has to see these before signing, and none of them is an `Entity`, so no scorecard row says it.
 */
export function Concepts({ rows }: { rows: readonly ConceptRow[] }): JSX.Element | null {
  if (rows.length === 0) {
    return null;
  }
  return (
    <section data-testid="concepts" aria-label={t("concepts.title")}>
      <h2>{t("concepts.title")}</h2>
      <ul>
        {rows.map((row) => (
          <li key={row.name} data-testid={`concept-${row.name}`}>
            <strong>{row.name.replace(/_/g, " ")}</strong>
            {row.reason === null ? null : `: ${row.reason}`}
          </li>
        ))}
      </ul>
    </section>
  );
}
